  import { useEffect } from "react";
  import { useLocation } from "react-router-dom";
  import Header from "./Header";
  import Footer from "./Footer";
  import WhatsAppButton from "./WhatsAppButton";
  import CallButton from "./CallButton";
  import ScrollToTop from "./ScrollToTop";
  import ContentProtection from "./ContentProtection";
  import SplashLoader from "./SplashLoader";
  import CookieBanner from "./CookieBanner";
  import AnalyticsLoader from "./AnalyticsLoader";

  export default function Layout({ children }) {
    const { pathname } = useLocation();
    useEffect(() => {
      // Preserve scroll position when returning to /products (from a product detail back-nav)
      if (pathname === "/products") {
        const saved = sessionStorage.getItem("stenzia_products_scroll");
        if (saved) {
          const y = parseInt(saved, 10);
          // Defer one frame so the page mounts before we restore scroll
          requestAnimationFrame(() =>
            window.scrollTo({ top: y, behavior: "instant" })
          );
          return;
        }
      }
      window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    // Save scroll position whenever the user is on /products
    useEffect(() => {
      if (pathname !== "/products") return;
      const onScroll = () => sessionStorage.setItem("stenzia_products_scroll", String(window.scrollY));
      window.addEventListener("scroll", onScroll, { passive: true });
      return () => window.removeEventListener("scroll", onScroll);
    }, [pathname]);

    return (
      <div className="min-h-screen flex flex-col bg-white">
        <SplashLoader />
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
        <WhatsAppButton />
        <CallButton />
        <ScrollToTop />
        <CookieBanner />
        <AnalyticsLoader />
        <ContentProtection />
      </div>
    );
  }
